import { Account, PublicAccount } from '../../common/data/accounts.js';
import { ensure, idToColor, makeInitials, maybe } from '../../common/util.js';
import { Id, Maybe } from '../../common/data.js';

interface Props {
	record?: Maybe<{
		to_account?: Maybe<Id<Account>>;
		account?: Maybe<Id<Account>>;
		account_name?: Maybe<string>;
		account_email?: Maybe<string>;
		account_avatar?: Maybe<string>;
	}>;
	account?: Maybe<PublicAccount>;
	uri?: Maybe<string>;
}

export function AccountAvatar({ account, record, uri }: Props) {
	if (!account && !record) return <span className="account-avatar" style={{ backgroundColor: '#777' }}>?</span>;
	const [id, avatar, email, name] = ensure(
		maybe(account, a => [a.id, a.avatar, a.account_email, a.account_name])
		?? maybe(record, aa => [aa.to_account || aa.account, aa.account_avatar, aa.account_email, aa.account_name])
	);
	if (!id) return <span className="account-avatar" style={{ backgroundColor: '#777' }}>?</span>;
	return <span className="account-avatar" style={
		(uri && { backgroundImage: `url('${uri}')` })
		?? maybe(avatar, fn => ({ backgroundImage: `url('/data/avatars/${fn}')` }))
		?? { backgroundColor: idToColor(id) }
	}>
		{!avatar && !uri && makeInitials(name || email || id)}
	</span>;
}
